import React, { useState } from 'react'
import Main from '../components/admin/Main';
import PageContainer from '../components/admin/PageContainer';
import Modal from '../components/admin/Modal';
import CartForm from '../components/admin/CartForm';
import CartList from '../components/admin/CartList';
import CollapseCard from '../components/admin/CollapseCard';

const CartPage = () => {
      const [showModal, setShowModal] = useState(false);
    
  return (
    <Main>
      <PageContainer
        title="Cart Page"
        buttonText={"ADD"}
        onButtonClick={() => {
          setShowModal(true);
        }}
      >
        {/* Add and Edit Form Modal */}
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
          }}
          headerText="Add Cart"
          centered
        >
          <CartForm />
        </Modal>

        <CollapseCard title="Cart List">
          <CartList />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
}

export default CartPage